import React from 'react';
import { Main } from '@klp/layout';
import { useGetProsjektConfluenceContentQuery } from '@klp/prosjekt/services/rtkApi';
import {
    Heading,
    Block,
    Typography,
    ActionButton,
    ActionLink,
    Link,
} from '@klp/design';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { Loader } from '@klp/design/Loader';
import ReactHtmlParser from 'react-html-parser';
import {
    reportMappingDocumentationPageId,
    reportMappingRoutes,
} from '../config';
import { sanitizeHtmlContent } from '@forvalter/utils/sanitizeHtmlContent';
import { useCurrentUser } from '@klp/auth';

export const ReportMappingDocumentationView: React.FC = () => {
    const { isEDAdmin } = useCurrentUser();
    const useStyles = makeStyles((theme) => ({
        errorContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'column',
        },
        errorContent: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: theme.spacing(1),
        },
        actionButtons: {},
    }));

    const classes = useStyles();

    const {
        data: confluenceContentData,
        isError: confluenceContentError,
        isLoading: confluenceContentLoading,
        isFetching: confluenceContentFetching,
    } = useGetProsjektConfluenceContentQuery({
        id: reportMappingDocumentationPageId,
    });

    return (
        <Main>
            <Main.Breadcrumbs>
                <Main.Crumb
                    id="reportMapping"
                    label="reportMapping.breadcrumbs.reportMapping"
                    href={reportMappingRoutes.moduleRoute()}
                />
                <Main.Crumb
                    id="reportMappingDocumentation"
                    label="reportMapping.breadcrumbs.documentation"
                    href={reportMappingRoutes.documentationRoute()}
                />
            </Main.Breadcrumbs>
            <Main.Navigation>
                <ActionLink
                    actionType="linkBack"
                    translation="reportMapping.documentation.backButton"
                    href={reportMappingRoutes.moduleRoute()}
                />
            </Main.Navigation>
            {!confluenceContentError ? (
                <Loader
                    isLoading={
                        confluenceContentLoading || confluenceContentFetching
                    }
                >
                    {confluenceContentData?.body && (
                        <>
                            <Heading
                                klpHeadingLevel="ONE"
                                klpColor="dark"
                                translation="reportMapping.documentation.title"
                            />
                            {isEDAdmin && (
                                <Block
                                    className={classes.actionButtons}
                                    paddingTop="tiny"
                                    paddingBottom="tiny"
                                >
                                    <Link
                                        href={confluenceContentData?.readLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        translation="reportMapping.documentation.viewInConfluence"
                                        endIcon={
                                            <Illustration
                                                icon={IconName.EXTERNAL}
                                            />
                                        }
                                    />
                                </Block>
                            )}
                            <Block paddingTop="tiny">
                                {ReactHtmlParser(
                                    sanitizeHtmlContent(
                                        confluenceContentData.body,
                                    ),
                                )}
                            </Block>
                        </>
                    )}
                </Loader>
            ) : (
                <Block marginTop="fat" className={classes.errorContainer}>
                    <Box className={classes.errorContent}>
                        <Typography
                            variant="h5"
                            translation="general.error.message"
                        />

                        <ActionButton
                            actionType="button"
                            translation="general.reload"
                            onClick={() => window.location.reload()}
                        />
                    </Box>
                </Block>
            )}
        </Main>
    );
};
